import React, { useEffect } from 'react'
import { makeStyles, useTheme } from '@mui/styles'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Card, CardContent } from '@mui/material'
import Alert from '@mui/material/Alert'
import { Link } from 'react-router-dom'
import { getCurrentProfileTeacher } from '../../../actions/profileTeacher'
import ReactPlayer from 'react-player'
import { format } from 'date-fns'
import EditIcon from '@mui/icons-material/Edit'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import DateRangeIcon from '@mui/icons-material/DateRange'
import ShowMoreText from 'react-show-more-text'
import { connect } from 'react-redux'
import Spinner from '../../../components/ui/Spinner'
import PropTypes from 'prop-types'
import './ReactPlayer.css'
import Reviews from '../../../components/teachers/Reviews/Reviews'
import { Cloudinary } from '@cloudinary/url-gen'
import styled from '@emotion/styled'

const Label = styled(Typography)({
  fontSize: '17px',
  fontWeight: 500,
})

const useStyles = makeStyles((theme) => ({
  rowContainer: {
    paddingLeft: '1.5em',
    paddingRight: '1.5em',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '3em',
      paddingRight: '3em',
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: '5em',
      paddingRight: '5em',
    },
  },
  formControl: {
    marginBottom: '0.5em',
  },
  degreeImage: {
    width: '100%',
    height: 'auto',
  },
  expImageCard: {
    maxWidth: 300,
  },
  expImage: {
    width: '100%',
    height: 'auto',
  },
  subHeader: {
    fontSize: '17px',
    fontWeight: '500',
  },
}))

const DashboardTeacher = ({
  auth: { user },
  profileTeacher: { profileTeacher, loading },
  getCurrentProfileTeacher,
}) => {
  const classes = useStyles()

  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  const cld = new Cloudinary({
    cloud: {
      cloudName: 'youspeak',
    },
  })

  let cldTeacherAvatar = ''
  if (profileTeacher && profileTeacher.teacherAvatar) {
    const cldRes = cld.image(profileTeacher.teacherAvatar)
    cldTeacherAvatar = cldRes.toURL()
  }

  let cldVideo = ''
  let cldThumbnail = ''
  if (profileTeacher && profileTeacher.video) {
    const cldRes = cld.video(profileTeacher.video)

    cldVideo = cldRes.toURL()

    cldThumbnail = cldVideo.split('?')[0]
    cldThumbnail = cldThumbnail + '.jpg'
  }

  let cldDegreeImages = []
  if (profileTeacher && profileTeacher.degreeImages.length > 0) {
    profileTeacher.degreeImages.forEach(image => {
      const cldRes = cld.image(image)

      const cldDegreeImage = cldRes.toURL()

      cldDegreeImages.push(cldDegreeImage)
    })
  }

  let cldExpImages = []
  if (profileTeacher && profileTeacher.expImages.length > 0) {
    profileTeacher.expImages.forEach(image => {
      const cldRes = cld.image(image)

      const cldExpImage = cldRes.toURL()

      cldExpImages.push(cldExpImage)
    })
  }

  const renderExpImages = (source) => {
    return source.map((photo, index) => {
      return (
        <Grid item className={classes.expImageCard} key={index}>
          <img
            src={photo}
            className={classes.expImage}
            alt="experience"
          />
        </Grid>
      )
    })
  }

  const renderDegreeImages = (source) => {
    return source.map((photo, index) => {
      return (
        <Grid item className={classes.expImageCard} key={index}>
          <img
            src={photo}
            className={classes.expImage}
            alt="experience"
          />
        </Grid>
      )
    })
  }

  const executeOnClick = () => { }

  useEffect(() => {
    getCurrentProfileTeacher()
  }, [getCurrentProfileTeacher])

  return <>
    {loading ? (
      <Spinner />
    ) : (
      <Grid
        container
        direction="column"
        className={classes.rowContainer}
        alignItems="center"
        spacing={2}
        style={{ margin: '7em 0 2em', width: '100%' }}
      >
        <Grid item style={{ textAlign: 'center' }}>
          <Typography
            variant="h4"
            style={{ textTransform: 'uppercase', fontWeight: '500' }}
          >
            Dashboard
          </Typography>
        </Grid>

        <Grid item style={{ alignSelf: 'flex-start' }}>
          <Typography variant="h5">
            Hello {user && user.name && user.name},
          </Typography>
        </Grid>

        {profileTeacher === null && (
          <Alert severity="warning">
            You haven't created your profile, please create your profile by
            clicking the edit button.
          </Alert>
        )}

        <Grid
          item
          container
          direction="column"
          alignItems="center"
          spacing={1}
          style={{ width: '100%', margin: '0' }}
        >
          <Grid item>{user && <Chip label={`ID: ${user._id}`} />}</Grid>

          <Grid item>
            <Avatar
              src={
                profileTeacher &&
                profileTeacher.teacherAvatar &&
                cldTeacherAvatar &&
                cldTeacherAvatar
              }
              style={{
                width: '80px',
                height: '80px',
              }}
            />
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction={matchesMD ? 'row' : 'column'}
          justifyContent="center"
          spacing={1}
        >
          <Grid item>
            <Button
              component={Link}
              variant="contained"
              color="primary"
              to="/teachers/create-profile"
              style={{ color: 'white' }}
            >
              <EditIcon fontSize="small" />
              &nbsp;Edit profile
            </Button>
          </Grid>
          <Grid item>
            <Button
              component={Link}
              variant="contained"
              color="primary"
              to="/teachers/lessons"
              style={{ color: 'white' }}
              disabled={!profileTeacher}
            >
              <MenuBookIcon fontSize="small" />
              &nbsp;Edit types of lesson
            </Button>
          </Grid>

          <Grid item>
            <Button
              component={Link}
              variant="contained"
              color="primary"
              to="/booking-calendar-teacher"
              style={{ color: 'white' }}
              disabled={!profileTeacher}
            >
              <DateRangeIcon fontSize="small" />
              &nbsp;Edit available time
            </Button>
          </Grid>
        </Grid>

        <Grid item>
          <Card>
            <CardContent>
              <Grid item>
                <Typography
                  style={{ textAlign: 'center', fontWeight: '500' }}
                  variant="h5"
                >
                  Personal Information
                </Typography>
              </Grid>

              <Grid container direction="column">
                {profileTeacher && profileTeacher.typeOfTeacher && (
                  <Grid item>
                    <Typography variant="body1">
                      <span className={classes.subHeader}>
                        Type of teacher:
                      </span>
                      &nbsp;
                      {profileTeacher.typeOfTeacher === 'professional'
                        ? 'Professional teacher'
                        : 'Community tutor'}
                    </Typography>
                  </Grid>
                )}

                {profileTeacher && profileTeacher.dateOfBirth !== null && (
                  <Grid item>
                    <Typography variant="body1">
                      <span className={classes.subHeader}>
                        Date of birth:{' '}
                      </span>
                      {format(
                        new Date(profileTeacher.dateOfBirth),
                        'dd/MM/yyyy'
                      )}
                    </Typography>
                  </Grid>
                )}

                {profileTeacher && profileTeacher.hometown && (
                  <Grid item>
                    <Typography variant="body1">
                      <span className={classes.subHeader}>From: </span>{' '}
                      {profileTeacher.hometown.label}
                    </Typography>
                  </Grid>
                )}

                {profileTeacher && profileTeacher.skypeId && (
                  <Grid item>
                    <Typography variant="body1">
                      <span className={classes.subHeader}>Skype ID: </span>
                      &nbsp;
                      {profileTeacher.skypeId}
                    </Typography>
                  </Grid>
                )}

                {profileTeacher && profileTeacher.phoneNumber && (
                  <Grid item>
                    <Typography variant="body1">
                      <span className={classes.subHeader}>
                        Phone number:{' '}
                      </span>
                      &nbsp;
                      {profileTeacher.phoneNumber}
                    </Typography>
                  </Grid>
                )}

                {profileTeacher && profileTeacher.introduction !== null && (
                  <Grid item>
                    <Label variant="body1">
                      Introduction about you:
                    </Label>
                    <Typography component={'span'} variant="body1">
                      <ShowMoreText
                        lines={3}
                        more="Read more"
                        less="Show less"
                        className="content-css"
                        anchorClass="my-anchor-css-class"
                        onClick={executeOnClick}
                        expanded={false}
                        width={700}
                      >
                        {profileTeacher.introduction}
                      </ShowMoreText>
                    </Typography>
                  </Grid>
                )}

                {
                  !profileTeacher && <Typography variant='body1' color='red'>
                    Your profile has not been created yet. Please create your profile by clicking the edit button.
                  </Typography>
                }
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {profileTeacher &&
          profileTeacher.cardNumber &&
          profileTeacher.nameOnCard &&
          profileTeacher.bankName && (
            <Grid item style={{ maxWidth: '25em' }}>
              <Card>
                <CardContent>
                  <Grid container direction="column" justifyContent="center">
                    <Grid item>
                      <Typography
                        variant="h5"
                        style={{ textAlign: 'center', fontWeight: '500' }}
                      >
                        Banking card's information:
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1">
                        <span className={classes.subHeader}>
                          Card number:
                        </span>
                        &nbsp;{profileTeacher.cardNumber}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1">
                        <span className={classes.subHeader}>
                          Name on card:
                        </span>
                        &nbsp;{profileTeacher.nameOnCard}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1">
                        <span className={classes.subHeader}>
                          Bank's name:
                        </span>
                        &nbsp;{profileTeacher.bankName}
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Typography variant='body1'>* Your card's information is used for delivering payments from your finished lessons.</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}

        {profileTeacher &&
          profileTeacher.video && (
            <Grid
              item
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              style={{ width: matchesLG ? '60%' : undefined }}
            >
              <Grid item>
                <Label variant="body1">
                  Introduction video:
                </Label>
              </Grid>
              <Grid item style={{ width: '100%' }}>
                {profileTeacher &&
                  profileTeacher.video &&
                  cldVideo && cldThumbnail && (
                    <div className="player-wrapper">
                      <ReactPlayer
                        className="react-player"
                        url={cldVideo}
                        light={cldThumbnail}
                        playing
                        controls
                        width="100%"
                        height="100%"
                      />
                    </div>)}
              </Grid>
            </Grid>
          )}

        {profileTeacher &&
          profileTeacher.degreeImages &&
          profileTeacher.degreeImages.length > 0 &&
          profileTeacher.typeOfTeacher !== 'commutor' && (
            <Grid item>
              <Card>
                <CardContent>
                  <Grid container direction="column">
                    <Grid item>
                      <Label
                        variant="body1"
                        style={{ textAlign: 'center' }}
                      >
                        Images of teaching certificates:
                      </Label>
                    </Grid>

                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      style={{ width: '100%', margin: '0' }}
                    >
                      {renderDegreeImages(cldDegreeImages)}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}

        {profileTeacher &&
          profileTeacher.expImages &&
          profileTeacher.expImages.length > 0 &&
          profileTeacher.typeOfTeacher !== 'commutor' && (
            <Grid item>
              <Card>
                <CardContent>
                  <Grid container direction="column">
                    <Grid item>
                      <Label
                        variant="body1"
                        style={{ textAlign: 'center' }}
                      >
                        Images of teaching experiences:
                      </Label>
                    </Grid>

                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      style={{ width: '100%', margin: '0' }}
                    >
                      {renderExpImages(cldExpImages)}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}

        <Grid item>
          <Reviews isTeacher={true} />
        </Grid>
      </Grid>
    )}
  </>;
}

DashboardTeacher.propTypes = {
  auth: PropTypes.object.isRequired,
  profileTeacher: PropTypes.object.isRequired,
  getCurrentProfileTeacher: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  profileTeacher: state.profileTeacher,
})

export default connect(mapStateToProps, { getCurrentProfileTeacher })(
  DashboardTeacher
)
